<template>
  <div class="filt-containt">
    <div class="select-box">
      <div class="single-box">
        <div class="title">{{ title }}：</div>
        <ul class="select-list">
          <li
            class="select-item"
            @click="handleSelect({name: KDApi.getLangMsg(model, 'tips.unlimited'), val: 'all'})"
            :class="{ activeted: selectedItem.val === 'all' }"
          >
            <!-- <span>不限</span> -->
            {{KDApi.getLangMsg(model, "filt.unlimited")}}
          </li>
          <li
            v-for="(item, index) in selectItemList"
            :key="'si' + index"
            class="select-item"
            :class="{ activeted: selectedItem.val === item.val }"
            @click="handleSelect(item)"
          >
            <span>{{ item.name }}</span>
          </li>
          <li class="select-item" :class="{ selfactiveted: selfVal }">
            <span style="margin-right: 10px">{{KDApi.getLangMsg(model, "filt.custom")}}</span>
            <el-date-picker
              v-model="mydate"
              type="daterange"
              range-separator="~"
              :start-placeholder="KDApi.getLangMsg(model, 'placeholder.startDate')"
              :end-placeholder="KDApi.getLangMsg(model, 'placeholder.endDate')"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              @change="changeDate"
            ></el-date-picker>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
// const ALL_VAL = { name: "不限", val: "all" };

export default {
  created() {
    
  },
  inject: ["model", "KDApi"],
  props: {
    title: String,
  },
  data() {
    return {
      selectItemList: [
        { name: KDApi.getLangMsg(this.model, 'filt.today'), val: 0 },
        { name: KDApi.getLangMsg(this.model, 'filt.thismonth'), val: 1 },
        { name: KDApi.getLangMsg(this.model, 'filt.recentmonth'), val: 2 },
      ],
      selectedItem: { name: KDApi.getLangMsg(this.model, "filt.unlimited"), val: "all" },
      mydate: "",
      selfVal: false,
    };
  },
  methods: {
    handleSelect(selectedItem) {
      this.mydate = "";
      this.selfVal = false;
      this.selectedItem = selectedItem;

      this.$emit("handleSelected", this.selectedItem);
    },
    changeDate() {
      this.selfVal = true;
      this.selectedItem = {
        name: KDApi.getLangMsg(this.model, 'tips.unlimited'),
        val: this.mydate,
      };

      this.$emit("handleSelected", this.selectedItem);
    },
  },
};

// data = [
//   {
//     id: "",
//     name: {
//       zh: "",
//       en: "",
//     },
//     no: [{}],
//     children: [
//       {
//         id: "",
//         name: {
//           zh: "",
//           en: "",
//         },
//         no: [{}],
//       },
//     ],
//   },
// ];
</script>

<style lang="less" scoped>
.filt-containt {
  width: 100%;
  height: 40px;
  align-items: center;
  border-top: 1px solid var(--weak-border-color);
  display: flex;
  justify-content: space-between;
  .select-box {
    flex: 1;
    .single-box {
      display: flex;
      align-items: center;
      flex: 1;
      .title {
        color: var(--third-text-color);
        font-size: 12px;
      }
      .select-list {
        flex-grow: 1;
        overflow: hidden;
        position: relative;
        list-style: none;
        display: flex;
        .select-item {
          display: flex;
          margin: 0 15px;
          align-items: center;
          border: 1px solid transparent;
          border-radius: 2px;
          cursor: pointer;
          color: var(--secondary-text-color);
          &.activeted {
            color: #5e80eb;
            border: 1px solid #5e80eb;
            background-color: #fff;
            border-radius: 2px;
            margin: 8px 12px;
            padding: 3px 12px;
          }
          &.selfactiveted {
            span {
              color: #5e80eb;
              border: 1px solid #5e80eb;
              background-color: #fff;
              border-radius: 2px;
              margin: 8px 12px;
              padding: 3px 12px;
            }
          }
        }
      }
    }
    &.activeted {
      background: #fff;
    }
  }
  .op-icon {
    display: flex;
    justify-content: center;
    min-width: 60px;
    height: 24px;
    padding: 0 5px;
    background: #fff;
    border: 1px solid #e2e2e2;
    border-radius: 2px;
    font-size: 12px;
    color: #5b6373;
    letter-spacing: 0;
    align-items: center;
    cursor: pointer;
  }
}
</style>

<style lang="less">
.select-item {
  .el-date-editor.el-range-editor.el-input__inner.el-date-editor--daterange {
    width: 240px;
    height: 21px;
  }
  .el-date-editor .el-range__close-icon {
    height: auto;
    line-height: normal;
  }
  .el-date-editor .el-range__icon {
    height: auto !important;
    font-size: 12px;
  }
  .el-range-editor .el-range-input {
    font-size: 12px;
  }
  .el-date-editor .el-range-separator {
    height: auto;
    line-height: normal;
    width: 18px;
    font-size: 12px;
  }
}
</style>


